import { render, staticRenderFns } from "./PageEatRight.vue?vue&type=template&id=0afa79cc&"
import script from "./PageEatRight.vue?vue&type=script&lang=js&"
export * from "./PageEatRight.vue?vue&type=script&lang=js&"
import style0 from "./PageEatRight.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports